/**
 * Enum for report media types
 */
export enum MediaTypeEnum {
  TABLE = 'table',
  PIE_CHART = 'pie chart'
}
